import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
})
export class SidenavComponent implements OnInit {
  accessmanagement: any;
  selectedlang: any = {};
  tcCode: any = "";
  usertype: any = "";
  subscriptionstatus = false;
  accessManagement: any = [];
  accessManagements: any = [];
  currentURL: any = "";
  dashboardMenu = {
    medicalsquesappointmentmenu: false,
    creditcardappointmentmenu: false,
    insuranceappointmentmenu: false,
    accessmanageappointmentmenu: false,
    basicinfoappointmentmenu: false,
    equipmentsappointmentmenu: false,
    frontdeskappointmentmenu: false,
    techniciansappointmentmenu: false,
    proceduresappointmentmenu: false,
  };
  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    this.usertype = sessionStorage.getItem("usertype");

    if (localStorage.getItem("testCode") !== null) {
      this.tcCode = localStorage.getItem("testCode");
    }

    this.subscriptionstatus =
      localStorage.getItem("subscriptionflag") &&
      localStorage.getItem("subscriptionflag") === "true"
        ? true
        : false;

    if (this.subscriptionstatus) {
      this.accessManagement = JSON.parse(
        localStorage.getItem("accessmanagement")
      );
      this.setaccessmanagement(this.accessManagement);
    } else if (!this.subscriptionstatus) {
      if (localStorage.getItem("accessmanagement")) {
        this.accessManagement = JSON.parse(
          localStorage.getItem("accessmanagement")
        );
        this.setaccessmanagement(this.accessManagement);
      } else {
        this.getAccessManagement();
      }
    }

    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
    if (sessionStorage.getItem("type")) {
      this.checkURL(sessionStorage.getItem("type"));
    } else {
      this.checkURL("basicinfo");
    }
  }

  getAccessManagement() {
    this.appservice.getFrontDeskAccessManagement().subscribe((res) => {
      if (res && res["entity"] && res["entity"].length > 0) {
        for (let index = 0; index < res["entity"].length; index++) {
          const groupBy =
            res["entity"][index]["accessManagement"]["accessType"];
          this.accessManagements[index] = res["entity"][index];
          this.accessManagements[index].groupBy = groupBy;
        }
        this.accessManagement = this.groupBy(this.accessManagements, "groupBy");

        this.setaccessmanagement(this.accessManagement);
      }
    });
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }

  setaccessmanagement(access) {
    for (let i = 0; i < access.length; i++) {
      if (access[i].value.length > 0 && access[i].key === "Admin") {
        for (let j = 0; j < access[i].value.length; j++) {
          if (sessionStorage.getItem("usertype") === "2") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Imaging Center Profile"
            ) {
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Basic Information"
              ) {
                this.dashboardMenu.basicinfoappointmentmenu =
                  access[i].value[j].admin;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Equipments"
              ) {
                this.dashboardMenu.equipmentsappointmentmenu =
                  access[i].value[j].admin;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Procedures"
              ) {
                this.dashboardMenu.proceduresappointmentmenu =
                  access[i].value[j].admin;
              }
              if (access[i].value[j].accessManagement.subMenu === "Insurance") {
                this.dashboardMenu.insuranceappointmentmenu =
                  access[i].value[j].admin;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Technicians"
              ) {
                this.dashboardMenu.techniciansappointmentmenu =
                  access[i].value[j].admin;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Front Desk"
              ) {
                this.dashboardMenu.frontdeskappointmentmenu =
                  access[i].value[j].admin;
              }
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Medical Questions"
              ) {
                this.dashboardMenu.medicalsquesappointmentmenu =
                  access[i].value[j].admin;
              }
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Access Management"
              ) {
                this.dashboardMenu.accessmanageappointmentmenu =
                  access[i].value[j].admin;
              }
            }
          } else if (sessionStorage.getItem("usertype") === "3") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Imaging Center Profile"
            ) {
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Medical Questions"
              ) {
                this.dashboardMenu.medicalsquesappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Credit Card"
              ) {
                this.dashboardMenu.creditcardappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (access[i].value[j].accessManagement.subMenu === "Insurance") {
                this.dashboardMenu.insuranceappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Access Management"
              ) {
                this.dashboardMenu.accessmanageappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Basic Information"
              ) {
                this.dashboardMenu.basicinfoappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Equipments"
              ) {
                this.dashboardMenu.equipmentsappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Front Desk"
              ) {
                this.dashboardMenu.frontdeskappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Technicians"
              ) {
                this.dashboardMenu.techniciansappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu === "Procedures"
              ) {
                this.dashboardMenu.proceduresappointmentmenu =
                  access[i].value[j].frontDesk;
              }
            }
          }
        }
      }
    }
  }
}
